export const config = {
    baseUrl: 'https://beta-app.djsdairy.com/api',
    frontUrl: 'https://center.djsdairy.com/',
    // baseUrl: 'http://localhost:8000/api',
    // frontUrl: 'http://localhost:3000/',
}